import _ from 'lodash'
import Vue from 'vue'
import { Store } from 'vuex'
import Component from 'vue-class-component'
import RootState from '../../store/state'
import { CmNotification } from '../../store/common/state'
import { Actions, Getters } from '../../store/common/helpers'
import isBrowserIE from '../../misc/is-browser-ie'
import TimerVue from './Timer.vue'

interface IconMap {
  [key: string]: string
}

const ICON_MAP: IconMap = {
  primary: 'fi-info',
  warning: 'fi-alert'
}

@Component({
  components: {
    'timer-vue': TimerVue
  }
})
export default class NotificationsVue extends Vue {
  $store: Store<RootState>

  get notifications(): CmNotification[] {
    return Getters.notifications(this.$store)
  }

  get hasNotifications(): boolean {
    return this.notifications.length !== 0
  }

  get isIE(): boolean {
    return isBrowserIE()
  }

  getLevel(notification: CmNotification): string {
    return notification.level || 'primary'
  }

  messageClass(notification: CmNotification): string {
    return `message--${this.getLevel(notification)}`
  }

  iconClass(notification: CmNotification): string {
    return ICON_MAP[this.getLevel(notification)] || 'fi-info'
  }

  remove(notification: CmNotification | string): void {
    Actions.removeNotification(this.$store, notification)
  }

  getLines(text: string): string[] {
    return text
      .trim()
      .replace(/\r?\n/g, '\n')
      .split('\n')
  }

  afterEnter(el: HTMLElement): void {
    const notification = this.getNotificationById(el.id)
    if (!notification) {
      return
    }
    notification._isTimerRunning = true
  }

  getNotificationById(id: string): CmNotification | undefined {
    return _.find(this.notifications, n => n.id === id)
  }

  getTimeout(notification: CmNotification): number {
    if (_.isNumber(notification.timeout)) {
      return notification.timeout
    }
    return (notification.level === 'warning') ? -1 : 5000
  }

  hasTimeout(notification: CmNotification): boolean {
    return this.getTimeout(notification) >= 0
  }

  trackRemove(notification: CmNotification): void {
    this.remove(notification)
  }

  trackTimeout(notification: CmNotification): void {
    this.remove(notification)
  }
}
